/** SETTINGS — onboarding state. The desk's team is the firm's (see ./firm). */
import { useQuery } from '@apollo/client';
import { MF_REGISTRATION } from '../queries';

/** Platform onboarding state for the signed-in account. */
export function useMfRegistration() {
  const { data, loading, error } = useQuery(MF_REGISTRATION, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });
  return { loading, error, registration: data?.mfRegistration ?? null };
}
